'use client'

import '@copilotkit/react-ui/styles.css'
import { Urbanist } from 'next/font/google'
import { SkeletonProvider } from '@/components/skeleton-provider'
import { Toaster } from '@/components/ui/sonner'
import { ClerkProvider } from '@clerk/nextjs'
import { ThemeProvider } from 'next-themes'
import React, { Suspense } from 'react'
import { TRPCProvider } from './_trpc/trpc-react-provider'
import { LoadingSpinner } from '@/components/LoadingSpinner'
import { PostHogProvider, PostHogUserIdentification } from './providers'
import './globals.css'
import { usePusherNotifications } from '@/hooks/usePusherNotifications'
import { CopilotKit } from '@copilotkit/react-core'

const urbanist = Urbanist({
    subsets: ['latin'],
    display: 'swap',
    variable: '--font-urbanist',
})

// export const metadata: Metadata = {
//     title: 'Vizible',
//     description: 'Vizible',
// }

// Basic full-page loading spinner for root Suspense
const RootLoadingFallback = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-background">
        <LoadingSpinner />
    </div>
)

// Component that calls the Pusher hook and renders children
function AppWithPusher({ children }: { children: React.ReactNode }) {
    usePusherNotifications()
    return <>{children}</>
}

export default function RootLayout({
    children,
}: Readonly<{
    children: React.ReactNode
}>) {
    return (
        <html lang="en" suppressHydrationWarning className={urbanist.variable}>
            <body className="overflow-hidden bg-background font-urbanist">
                <Suspense fallback={<RootLoadingFallback />}>
                    <PostHogProvider>
                        {/* <CopilotKit runtimeUrl="/api/copilotkit" agent="onboardingAgent"> */}
                        <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
                            <ClerkProvider
                                appearance={{
                                    userButton: {
                                        variables: {
                                            colorPrimary: 'blue',
                                            colorText: 'black',
                                        },
                                    },
                                }}
                            >
                                <PostHogUserIdentification />
                                <TRPCProvider>
                                    <AppWithPusher>
                                        <SkeletonProvider>{children}</SkeletonProvider>
                                    </AppWithPusher>
                                </TRPCProvider>
                            </ClerkProvider>
                            <Toaster />
                        </ThemeProvider>
                        {/* </CopilotKit> */}
                    </PostHogProvider>
                </Suspense>
            </body>
        </html>
    )
}
